// extracted by mini-css-extract-plugin
export default {"likesCount":"dCVSu0WGHgmx7BTqUz7Z","likeIcon":"ARYZOBvV3FaZlOHhqsiB"};